import { render, staticRenderFns } from "./BudgetHistoryDialog.vue?vue&type=template&id=37f688a0&scoped=true"
import script from "./BudgetHistoryDialog.vue?vue&type=script&lang=js"
export * from "./BudgetHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./BudgetHistoryDialog.vue?vue&type=style&index=0&id=37f688a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f688a0",
  null
  
)

export default component.exports